module.exports = "<div mat-dialog-content style=\"text-align: center\">\r\n    <p>Income Classification was Successfully Added</p>\r\n</div>"